module.exports = __webpack_public_path__ + "static/media/Vanguard.9cf353c8.png";